/**
 * Animated SVG spinner used inside buttons to indicate a loading state.
 * Inherits the button's text color so it stays visible on both the green and grey button states.
 * Only the moving arc is drawn — there is deliberately no static track circle behind it.
 */
export const LoadingSpinner = () => (
  <svg
    className='animate-spin h-5 w-5'
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'>
    <path
      fill='currentColor'
      d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
    />
  </svg>
);
